import {combineReducers} from '@reduxjs/toolkit';
import {planRootSlice} from './planRootSlice';
import vaultReducer from '../vault/vaultSlice';
import floorReducer from '../floor/floorSlice';
import lidReducer from '../lid/lidSlice';
import intermediateCeilingReducer from '../intermediateCeiling/intermediateCeilingSlice';
import {planDirtyReducer} from './planDirtyReducer';
import {initialPlanState} from "./initialPlanState";
import {planApiActionTypes as apiActionTypes} from "../../constants";

const childrenReducer = combineReducers({
    vault: vaultReducer, lid: lidReducer, intermediateCeiling: intermediateCeilingReducer, floor: floorReducer,
});

export const reset = () => ({type: 'plan/reset'});


const planReducer = (state = initialPlanState, action) => {
    switch (action.type) {
        case 'persist/REHYDRATE':
            if (action.payload && action.payload.plan) {
                return action.payload.plan;
            }
            return state;
        case reset().type:
            return initialPlanState;
        case apiActionTypes.readPlanSuccess:
            return action.data;
        default:
            // Process the root slice
            const updatedRootState = planRootSlice.reducer(state, action);

            // Determine the source state for children reducers based on rehydration
            const isRehydrate = action.type === 'persist/REHYDRATE' && action.payload && action.payload.plan;
            const sourceForChildren = isRehydrate ? action.payload.plan : state;

            // Pass the children-related properties to the children reducer
            const childrenState = childrenReducer({
                vault: sourceForChildren.vault,
                lid: sourceForChildren.lid,
                intermediateCeiling: sourceForChildren.intermediateCeiling,
                floor: sourceForChildren.floor,
            }, action);

            const rootChanged = updatedRootState !== state;
            const vaultChanged = childrenState.vault !== state.vault;
            const lidChanged = childrenState.lid !== state.lid;
            const intermediateCeilingChanged = childrenState.intermediateCeiling !== state.intermediateCeiling;
            const floorChanged = childrenState.floor !== state.floor;

            if (!rootChanged && !vaultChanged && !lidChanged && !intermediateCeilingChanged && !floorChanged) {
                return state;
            }

            return {
                ...updatedRootState, ...childrenState,
            };
    }
};

export default planDirtyReducer(planReducer);
